import {
  AriaLabels,
  Benefits,
  Stack
} from '@com-delta-idp/mnx-skymiles-overview-ui';
import {
  AEMBenefits,
  AEMErrorMessage,
  AEMTier,
  TierType,
  UserSession,
  getEmptyContent,
  isDisplay,
  isValidData
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';

export const getBenefits = (
  aem: AEMBenefits | undefined,
  profile: UserSession | undefined,
  featureFlag: boolean | undefined,
  aemErrorMessages: AEMErrorMessage[] | undefined
): Benefits => {
  try {
    return isValidData<
      AEMBenefits,
      [AEMBenefits | undefined, UserSession | undefined, boolean | undefined]
    >('actions', aem, profile, featureFlag)
      ? adaptBenefits(
          aem as AEMBenefits,
          profile as UserSession,
          featureFlag as boolean
        )
      : isDisplay<Benefits>(featureFlag);
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'OVERVIEW', 'BENEFITS');
    return getEmptyContent<Benefits>('benefits', aemErrorMessages, true, true);
  }
};

export const adaptBenefits = (
  aem: AEMBenefits,
  profile: UserSession,
  featureFlag: boolean
): Benefits => {
  return featureFlag
    ? {
        actions: aem.actions,
        title: aem.title,
        stacks: getStacksData(aem, profile),
        disabled: !featureFlag,
        loaded: true
      }
    : getEmptyContent<Benefits>('', [], true, true);
};

export const getStacksData = (
  aem: AEMBenefits,
  profile: UserSession
): Stack[] => {
  const stack: Stack[] = [];
  const diamondMedallionIndex = aem.tiers.findIndex(
    (item) => item.medallionId === 'DM'
  );
  const tierIndex = aem.tiers.findIndex(
    (item) => item.medallionId === profile.membershipLevel
  );
  const tiers = profile.is360Tier
    ? aem.tiers.slice(diamondMedallionIndex + 1)
    : aem.tiers.slice(0, diamondMedallionIndex + 1);

  tiers.forEach((value: AEMTier, index) => {
    const result = {
      title: value.title.replace(
        /\[.*?\]/,
        `<span>${value.memberStatus}</span>`
      ),
      current: profile.is360Tier ? false : tierIndex === index,
      ariaLabels: getLabelsData(value),
      tier: profile.is360Tier
        ? (value.bannerLabel.split(' ')[1].split('&')[0] as TierType)
        : (value.bannerLabel.split(' ')[0].toLowerCase() as TierType),
      goodies: value.goodies
    };
    stack.push(result);
  });
  return stack;
};

export const getLabelsData = (value: AEMTier): AriaLabels => {
  return {
    banner: value.bannerLabel,
    peekBar: value.peekBarLabel
  };
};
